import React from 'react';
import { translate, Translate } from 'react-jhipster';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

interface BranchManagerSalesCardProps {
  eachTotalSales: any[];
  currency: string;
  lang?: string;
  onNavigate: (path: string) => void;
}

export const BranchManagerSalesCard = ({ eachTotalSales, currency, lang = 'en', onNavigate }: BranchManagerSalesCardProps) => {
  const cellSx = { borderBottom: 'none', textAlign: lang === 'en' ? 'left' : 'right' } as const;

  return (
    <Paper className="summary-paper">
      <Typography variant="subtitle1" fontWeight={600} mb={2} letterSpacing="-0.01em" component="div">
        <Translate contentKey="home.topInfo.bankStaffSales" interpolate={{ currency }} />
      </Typography>
      <TableContainer sx={{ maxHeight: 140, marginTop: '20px' }}>
        <Table size="small">
          <TableBody>
            {eachTotalSales?.map(row => (
              <TableRow key={row.id}>
                <TableCell sx={cellSx}>{row.name}</TableCell>
                <TableCell align="right" sx={cellSx}>{row.totalSales?.toLocaleString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Button onClick={() => onNavigate('reports')} className="mt-4" sx={{ textTransform: 'none' }}>
        {translate('home.topInfo.viewDetails')}
      </Button>
    </Paper>
  );
};

export default BranchManagerSalesCard;
